export default {
    brush: {
        title: 'Escova',
        brushHardness: 'Dureza do pincel',
        brushSize: 'Tamanho do pincel',
        brushColor: 'Cor do pincel',
    },
};
